import gql from 'graphql-tag';

import type { ProjectSearchOptions } from 'src/data/project/types';
import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_PROJECT_FOLDER_FOR_SEARCH } from 'src/graphql/projectFolder';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQuerySearchProjectAndProjectFoldersArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_FOR_SEARCH } from './schema';

const QUERY = gql`
  query searchProjectAndProjectFolders($workspaceId: ID!, $term: String!) {
    searchProjectAndProjectFolders(term: $term, workspaceId: $workspaceId) {
      ...ProjectForSearch
      ...ProjectFolderForSearch
    }
  }
  ${FRAGMENT_PROJECT_FOR_SEARCH}
  ${FRAGMENT_PROJECT_FOLDER_FOR_SEARCH}
`;

type Variables = BackendQuerySearchProjectAndProjectFoldersArgs;
type Result = ProjectSearchOptions[];

export const searchProjectAndProjectFolders = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
